document.addEventListener('DOMContentLoaded', function() {
  // --- CONSTANTS ---
  const API_URL = 'https://shazory-contest-api-development.summer-wildflower-4a12.workers.dev/api/v1/ai-creations/generate';
  const API_PREFIX = 'https://shazory-contest-api-development.summer-wildflower-4a12.workers.dev/api/v1';
  const LATEST_API_URL = 'https://shazory-contest-api-development.summer-wildflower-4a12.workers.dev/api/v1/ai-creations/latest';

  // --- ELEMENT SELECTORS ---
  const generateButton = document.querySelector('.ai-prod-button .button--primary');
  const aiModal = document.querySelector('.ai-image-generate-model');
  const closeModalButton = document.querySelector('.close_modal a');
  
  const aiForm = document.getElementById('ai-generate-form');
  const submitButton = document.getElementById('ai-submit-button');
  const promptInput = document.getElementById('ai-prompt');
  const imageInput = document.getElementById('file-upload');
  const agreementCheckbox = document.getElementById('ai-agreement-checkbox');
  const apiErrorContainer = document.getElementById('ai-api-error'); // For server errors

  const step1 = document.querySelector('.al-step-1');
  const step2 = document.querySelector('.al-step-2');
  const aiLoader = document.querySelector('.ai-loader');
  const resultImage = document.getElementById('ai-result-image');
  const downloadLink = document.getElementById('ai-download-link');
  const remainingGenerationsText = document.getElementById('remaining-generations');
  const generateNewButton = document.getElementById('generate-new-button');
  const iosInstruction = document.querySelector('.ios-save-instruction');

  // Exit if essential elements aren't on the page
  if (!aiModal || !aiForm) {
    return;
  }

  // --- INLINE VALIDATION FUNCTIONS ---
  function showInlineError(inputElement, message) {
    const errorElementId = inputElement.id + '-error';
    const errorElement = document.getElementById(errorElementId);
    const targetElement = inputElement.type === 'checkbox' ? inputElement.nextElementSibling : inputElement;
    
    targetElement.classList.add('is-invalid');
    if (errorElement) {
      errorElement.textContent = message;
      errorElement.style.display = 'block';
    }
  }

  function clearInlineError(inputElement) {
    const errorElementId = inputElement.id + '-error';
    const errorElement = document.getElementById(errorElementId);
    const targetElement = inputElement.type === 'checkbox' ? inputElement.nextElementSibling : inputElement;

    targetElement.classList.remove('is-invalid');
    if (errorElement) {
      errorElement.style.display = 'none';
      errorElement.textContent = '';
    }
  }

  function validatePrompt() {
    clearInlineError(promptInput);
    if (promptInput.value.trim() === '') {
      showInlineError(promptInput, 'The prompt field cannot be empty.');
      return false;
    }
    return true;
  }

  function validateAgreement() {
    clearInlineError(agreementCheckbox);
    if (!agreementCheckbox.checked) {
      showInlineError(agreementCheckbox, 'You must agree to the terms to proceed.');
      return false;
    }
    return true;
  }

  // --- CORE UI AND API FUNCTIONS ---
  function openModal() {
    aiModal.classList.add('active');
    document.body.style.overflow = 'hidden';
    fetchRemainingGenerations();
  }

  function closeModal() {
    aiModal.classList.remove('active');
    document.body.style.overflow = '';
  }

  function resetToStep1() {
    step2.style.display = 'none';
    step1.style.display = 'block';
    aiForm.reset(); // Native form method to clear all fields
    clearInlineError(promptInput);
    clearInlineError(agreementCheckbox);
    apiErrorContainer.style.display = 'none';
    // if(iosInstruction) {
    //   iosInstruction.style.display = 'none'; // Also hide instructions on reset
    // }
    downloadLink.textContent = 'Download';
  }

  async function handleFormSubmit(event) {
    event.preventDefault();
    apiErrorContainer.style.display = 'none';

    // Run all validations and check if the form is valid
    const isPromptValid = validatePrompt();
    const isAgreementValid = validateAgreement();
    if (!isPromptValid || !isAgreementValid) {
      return; // Stop submission if validation fails
    }
    
    const customerId = aiModal.dataset.customerId;
    if (!customerId || customerId === '0' || customerId === '') {
      apiErrorContainer.textContent = 'You must be logged in to generate an image.';
      apiErrorContainer.style.display = 'block';
      return;
    }
    
    // Enter loading state
    submitButton.disabled = true;
    aiLoader.style.display = 'block';
    step1.style.display = 'none';

    // Prepare form data for API
    const formData = new FormData();
    formData.append('prompt', promptInput.value.trim());
    formData.append('shopify_customer_id', customerId);
    if (imageInput.files.length > 0) {
      formData.append('image', imageInput.files[0]);
    }

    try {
      const response = await fetch(API_URL, { method: 'POST', body: formData });
      const result = await response.json();
      if (!response.ok || !result.success) {
        let errorMessage = 'An unknown error occurred. Please try again.';
        if (result.error && result.error.message) {
          errorMessage = result.error.message; // Use the new, more specific error message
        } else if (result.message) {
          errorMessage = result.message; // Fallback to the old format if needed
        }
        throw new Error(errorMessage);
      }

      // Handle successful response
      const fullImageUrl = API_PREFIX + result.data.imageUrl;
      resultImage.src = fullImageUrl;
      downloadLink.href = fullImageUrl;
      remainingGenerationsText.textContent = `You have ${result.data.remainingGenerations} generations left today.`;
      
      aiLoader.style.display = 'none';
      step2.style.display = 'block';

      // const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      // if (isIOS && iosInstruction) {
      //   iosInstruction.style.display = 'block';
      //   downloadLink.textContent = 'Open Full Image';
      // }

    } catch (error) {
      // Handle errors
      step1.style.display = 'block';
      aiLoader.style.display = 'none';
      apiErrorContainer.textContent = error.message;
      apiErrorContainer.style.display = 'block';
    } finally {
      // This always runs, whether success or fail
      submitButton.disabled = false;
    }
  }

  async function forceDownload(url, filename) {
    const originalText = downloadLink.textContent;
    try {
      downloadLink.textContent = 'Downloading...';
      const response = await fetch(url);
      if (!response.ok) { throw new Error(`Network response was not ok`); }
      
      const blob = await response.blob();
      const objectUrl = window.URL.createObjectURL(blob);
      const tempLink = document.createElement('a');
      tempLink.href = objectUrl;
      tempLink.download = filename || 'generated-image.png';
      
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(objectUrl);

    } catch (error) {
      console.error('Download failed:', error);
      alert('Could not download the image. Please try again.');
    } finally {
      downloadLink.textContent = originalText;
    }
  }

  // --- Function to fetch the latest generation count on modal open ---
async function fetchRemainingGenerations() {
  const customerId = aiModal.dataset.customerId;

  // If customer is not logged in, set a default message and stop.
  if (!customerId || customerId === '0' || customerId === '') {
    remainingGenerationsText.textContent = 'Login to see your generations.';
    return;
  }

  // Set a loading state to give the user feedback
  remainingGenerationsText.textContent = 'Loading generations...';

  try {
    const response = await fetch(LATEST_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ shopify_customer_id: customerId })
    });

    const result = await response.json();

    if (!response.ok || !result.success) {
      throw new Error('Failed to fetch generation count.');
    }

    // On success, update the text with the correct count
    const count = result.data.remainingGenerations;
    remainingGenerationsText.textContent = `You have ${count} generations left today.`;

  } catch (error) {
    // If the API call fails, show a user-friendly error message
    console.error("Error fetching remaining generations:", error);
    remainingGenerationsText.textContent = 'Could not load generations.';
  }
}
  
  // --- EVENT LISTENERS ---
  // Using optional chaining (?.) for safety in case elements don't exist
  generateButton?.addEventListener('click', e => { e.preventDefault(); openModal(); });
  closeModalButton?.addEventListener('click', e => { e.preventDefault(); closeModal(); });
  aiModal?.addEventListener('click', e => { if (e.target === aiModal) closeModal(); });
  document.addEventListener('keydown', e => { if (e.key === "Escape" && aiModal.classList.contains('active')) closeModal(); });
  aiForm?.addEventListener('submit', handleFormSubmit);
  generateNewButton?.addEventListener('click', e => { e.preventDefault(); resetToStep1(); });
  downloadLink?.addEventListener('click', e => { e.preventDefault(); forceDownload(e.currentTarget.href, e.currentTarget.getAttribute('download')); });
  // downloadLink?.addEventListener('click', e => {
  //   e.preventDefault();
  //   const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  //   const url = e.currentTarget.href;
  //   const filename = e.currentTarget.getAttribute('download');

  //   if (isIOS) {
  //     window.open(url, '_blank');
  //   } else {
  //     forceDownload(url, filename);
  //   }
  // });
  
  // Real-time validation listeners
  promptInput?.addEventListener('blur', validatePrompt); // Validate when user clicks away from the textarea
  agreementCheckbox?.addEventListener('change', validateAgreement); // Validate when the checkbox state changes
});